import React from "react";
import PropTypes from "prop-types";
import { displayVarsomePremiumLogo } from "../../../common/helpers/helpers";
import { geneFields, variantFields } from "./helpers";
import HelperText from "../../../components/atoms/HelperText";

const ClinicalEvidencesTableHeaders = ({ isGene }) => {
  const fields = isGene ? geneFields : variantFields;
  const header = (
    <tr>
      {fields.map((entry) => {
        return (
          <th
            className="tw-overflow-wrap-break-word"
            key={entry.title}
            width={entry.width}
          >
            {entry.title}
            <HelperText fieldDescriptionKey={entry.title} />
            {entry.key === "drugs" ? displayVarsomePremiumLogo(false) : ""}
          </th>
        );
      })}
    </tr>
  );

  return <thead>{header}</thead>;
};

ClinicalEvidencesTableHeaders.propTypes = {
  isGene: PropTypes.bool,
};

ClinicalEvidencesTableHeaders.defaultProps = {
  isGene: false,
};

export default ClinicalEvidencesTableHeaders;
